import { render, staticRenderFns } from "./AddCustomInvestorGoalCard.vue?vue&type=template&id=57156212&scoped=true&"
import script from "./AddCustomInvestorGoalCard.vue?vue&type=script&lang=ts&"
export * from "./AddCustomInvestorGoalCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddCustomInvestorGoalCard.vue?vue&type=style&index=0&id=57156212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57156212",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VImg,VRow})
